import React from 'react';

const TerminalMark = () => <div className="terminal-mark text-center mb-4"><span>✓</span></div>;

export default TerminalMark;
